import { useState } from "react";
import { useAuth } from "../contexts/AuthContext";
import { KeyRound, Loader2, ShieldCheck, Eye, EyeOff } from "lucide-react";

const LOGO_URL = "https://customer-assets.emergentagent.com/job_client-portal-252/artifacts/ymujr84m_Logo%20blitzz%20%2B%20BYB%20ok%20sans%20fond%20copie.png";

export const FirstPasswordGate = () => {
  const { user, axiosAuth, checkAuth, logout } = useAuth();
  const api = axiosAuth();
  const [pw, setPw] = useState("");
  const [confirm, setConfirm] = useState("");
  const [show, setShow] = useState(false);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    if (pw.length < 12 || !/[A-Z]/.test(pw) || !/[a-z]/.test(pw) || !/\d/.test(pw) || !/[^A-Za-z0-9]/.test(pw)) {
      setError("12 caractères minimum avec une majuscule, une minuscule, un chiffre et un symbole."); return;
    }
    if (pw !== confirm) { setError("Les deux mots de passe ne correspondent pas."); return; }
    setLoading(true);
    try {
      await api.post("/auth/first-password", { new_password: pw });
      await checkAuth();
    } catch (err) {
      setError(err.response?.data?.detail || "Erreur lors du changement de mot de passe");
    }
    setLoading(false);
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-4" style={{ background: "#0b0811" }} data-testid="first-password-gate">
      <div className="w-full max-w-md">
        <img src={LOGO_URL} alt="Blitzz" className="h-14 mx-auto mb-6 object-contain" />
        <div className="bg-[#14101c] border border-white/10 rounded-2xl p-7">
          <div className="w-12 h-12 rounded-xl flex items-center justify-center mb-4" style={{ background: "#f7c93515", border: "1px solid #f7c93530" }}>
            <KeyRound className="w-6 h-6" style={{ color: "#f7c935" }} />
          </div>
          <h1 className="text-xl font-black text-white mb-1.5">Bienvenue {user?.name?.split(" ")[0] || ""} 👋</h1>
          <p className="text-sm text-slate-400 mb-6">
            Pour sécuriser votre compte, choisissez votre mot de passe personnel avant d'accéder à la plateforme.
          </p>
          {error && (
            <div className="text-red-400 text-sm mb-4 bg-red-500/10 border border-red-500/20 rounded-lg px-3 py-2" data-testid="first-password-error">
              {error}
            </div>
          )}
          <form onSubmit={submit} className="space-y-4">
            <div>
              <label className="text-xs font-bold text-slate-400 uppercase tracking-wide mb-1.5 block">Nouveau mot de passe</label>
              <div className="relative">
                <input
                  type={show ? "text" : "password"}
                  value={pw}
                  onChange={(e) => setPw(e.target.value)}
                  className="w-full bg-[#0b0811] border border-white/10 rounded-lg px-3 py-2.5 text-sm text-white pr-10 focus:border-[#f7c935]/50 outline-none"
                  placeholder="12 caractères min., majuscule, chiffre, symbole"
                  autoFocus
                  data-testid="first-password-input"
                />
                <button type="button" onClick={() => setShow(!show)} className="absolute right-3 top-1/2 -translate-y-1/2 text-slate-500 hover:text-white">
                  {show ? <EyeOff className="w-4 h-4" /> : <Eye className="w-4 h-4" />}
                </button>
              </div>
            </div>
            <div>
              <label className="text-xs font-bold text-slate-400 uppercase tracking-wide mb-1.5 block">Confirmez le mot de passe</label>
              <input
                type={show ? "text" : "password"}
                value={confirm}
                onChange={(e) => setConfirm(e.target.value)}
                className="w-full bg-[#0b0811] border border-white/10 rounded-lg px-3 py-2.5 text-sm text-white focus:border-[#f7c935]/50 outline-none"
                data-testid="first-password-confirm"
              />
            </div>
            <button
              type="submit"
              disabled={loading || !pw || !confirm}
              className="w-full flex items-center justify-center gap-2 py-2.5 rounded-lg font-bold text-sm transition-colors disabled:opacity-50"
              style={{ background: "#f7c935", color: "#0b0811" }}
              data-testid="first-password-submit"
            >
              {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : <ShieldCheck className="w-4 h-4" />}
              Définir mon mot de passe
            </button>
          </form>
          <button onClick={logout} className="w-full text-center text-xs text-slate-500 hover:text-slate-300 mt-4" data-testid="first-password-logout">
            Se déconnecter
          </button>
        </div>
      </div>
    </div>
  );
};

export default FirstPasswordGate;
